<template>
  <div class="publication-table" :class="[css, 'pt-2xl']">
    <inner-search :search-string.sync="searchString" />
    <div class="table-wrap">
      <table v-if="dimensions.width > 600">
        <thead>
          <th
            @click="sortTable(index)"
            v-for="(label, index) in parsedKeys"
            :key="label"
          >
            <div class="inner-cell">
              <i
                :class="[
                  'fad',
                  'mr-xs',
                  sort.labels.indexOf(tableKeys[index]) > -1
                    ? sort.directions[sort.labels.indexOf(tableKeys[index])] ===
                      'asc'
                      ? 'fa-sort-down'
                      : 'fa-sort-up'
                    : 'fa-sort'
                ]"
              ></i>
              <strong v-text="label"></strong>
            </div>
          </th>
        </thead>
        <paginate
          ref="paginator"
          name="filteredChildren"
          :list="filteredChildren"
          :per="itemsPerPage"
          tag="tbody"
        >
          <tr
            v-for="item in paginated('filteredChildren')"
            :key="item.Article_Title"
          >
            <td
              v-for="k in tableKeys"
              :key="k"
              v-html="parseCellContent(item[k])"
            ></td>
          </tr>
        </paginate>
      </table>
      <div v-else class="responsive-view">
        <paginate
          ref="paginator"
          name="filteredChildren"
          :list="filteredChildren"
          :per="itemsPerPage"
          tag="div"
        >
          <div
            class="responsive-view--section p-xl mb-xl"
            v-for="item in paginated('filteredChildren')"
            :key="item.Article_Title"
          >
            <div
              v-for="(k, i) in tableKeys"
              :key="k"
              :class="[
                'responsive-view--item',
                'pb-xs',
                `item__${k.toLowerCase()}`
              ]"
            >
              <template v-if="item[k]">
                <strong
                  v-if="i > 1 && i < tableKeys.length - 1"
                  v-text="startCase(k) + ': '"
                ></strong>
                <span v-html="parseCellContent(item[k])"> </span>
              </template>
            </div>
          </div>
        </paginate>
      </div>
    </div>
    <transition name="slide-up" appear>
      <div class="pager align-left pt-l" v-if="filteredChildren.length > 12">
        <paginate-links
          id="pager"
          ref="pager"
          for="filteredChildren"
          :limit="4"
          :show-step-links="true"
          @change="onLangsPageChange"
          :step-links="{ next: localize('Next'), prev: localize('Prev') }"
        ></paginate-links>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    children: Array,
    title: String,
    hasSearch: {
      type: Boolean,
      default: false
    },
    css: {
      type: String,
      default: ""
    },
    events: {
      type: Boolean,
      default: false
    },
    properties: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      openPublications: [],
      searchActive: false,
      searchString: null,
      itemsPerPage: 12,
      sort: {
        labels: ["Year"],
        directions: ["desc"]
      },
      paginate: ["filteredChildren"]
    };
  },
  mounted() {
    // this.setMediaChildrenToGallery();
  },
  watch: {
    "sort.labels"() {
      console.log("sort labels changed > ", this.sort.labels);
      if (!this.sort.labels.length) {
        this.$set(this.sort, "labels", ["Year"]);
        this.$set(this.sort, "directions", ["desc"]);
      }
    }
  },
  methods: {
    lowerCase(string) {
      return string.toLowerCase();
    },
    startCase(string) {
      return _.startCase(string);
    },
    parseCellContent(_string) {
      if (_string && _string.indexOf("http") > -1) {
        return `<a href="${_string}" target="_blank" title="Abstract address: ${_string}">View Abstract</a>`;
      }
      return _string;
    },
    sortDirection(index) {
      let label = this.tableKeys[index];
      let labelIndex = this.sort.labels.indexOf(label);
      if (labelIndex > 0) {
        return this.sort.directions[labelIndex];
      }
      return null;
    },
    sortIcon(index) {
      let label = this.tableKeys[index];
      let labelIndex = this.sort.labels.indexOf(label);
      // console.log("labelIndex>> ", labelIndex);
      if (labelIndex > -1) {
        let labelSortDirection = this.sort.directions[labelIndex];
        // console.log("labelSortDirection > ", labelSortDirection);
        if (labelSortDirection === "desc") {
          return "fa-sort-down";
        }
        return "fa-sort-up";
      }
      return "fa-sort";
      // this.sort.directions
      // this.sort.labels
    },
    sortTable(index) {
      let label = this.tableKeys[index];
      let labelIndex = this.sort.labels.indexOf(label);
      if (labelIndex > -1) {
        let labelSortDirection = this.sort.directions[labelIndex];
        if (labelSortDirection === "desc") {
          this.$set(this.sort.directions, labelIndex, "asc");
        } else {
          this.sort.labels.splice(labelIndex, 1);
          this.sort.directions.splice(labelIndex, 1);
        }
      } else {
        this.sort.labels.unshift(label);
        this.sort.directions.unshift("desc");
      }
    },
    getOffset(el) {
      var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
    },
    onLangsPageChange() {
      let el = this.$el.parentElement,
        offset = this.getOffset(el);
      if (el) {
        let top = offset.top - 120;
        window.scrollTo({ top, behavior: "smooth" });
      }
    },
    togglePublication(id) {
      let _pubs = _.clone(this.openPublications);
      let _i = _pubs.indexOf(id);

      if (_i > -1) {
        _pubs.splice(_i, 1);
      } else {
        _pubs.push(id);
      }
      this.$set(this, "openPublications", _pubs);
      this.$emit("content-loaded");
    },
    isOpen(id) {
      return this.openPublications.indexOf(id) > -1;
    },
    beforeEnter: function(el) {
      el.style.opacity = 0;
      el.style.transform = "translateY(80%)";
    },
    enter: function(el, done) {
      let lapse = 180,
        delay = el.dataset.index * lapse;
      setTimeout(function() {
        el.animate(
          {
            opacity: [0, 1],
            transform: ["translateY(80%)", "translateY(0)"],
            easing: "cubic-bezier(0.175, 0.885, 0.32, 1.275)"
          },
          { duration: 600, fill: "forwards" }
        ).onfinish = function() {
          done();
        };
      }, delay);
    },
    leave: function(el, done) {
      el.style.opacity = 0;
      el.style.transform = "translateY(120%)";
      done();
    }
  },
  computed: {
    ...mapState(["dimensions"]),
    parsedChildren() {
      let children = this.children; //_.orderBy(this.children, "id", ["desc"]);
      children = children.map(child =>
        JSON.parse(child.content.replace(/(<p>|<\/p>)/g, ""))
      );
      children.forEach(child => {
        child.Article_Title = _.trim(child.Article_Title).replace(/'/g, "");
        child.Author = _.trim(child.Author).replace(/'/g, "");
      });
      return children;
    },
    filteredChildren() {
      let _s = this.sort;
      let _children = this.parsedChildren; //= _.cloneDeep(this.parsedChildren);
      if (this.searchString && this.searchString.length > 1) {
        _children = _children.filter(child => {
          let __s = (
            child.Article_Title +
            child.Author +
            child.Journal +
            child.Issue +
            child.MIS_Products_Used +
            child.Year
          ).toLowerCase();
          return __s.indexOf(this.searchString.toLowerCase()) > -1;
        });
      }
      // if (_s.labels.length) {
      // let labels = _s.labels.length ? _s.labels : ["Year"];
      // let directions = _s.labels.length ? _s.directions : ["desc"];
      _children = _.orderBy(_children, _s.labels, _s.directions);
      // }

      // RETURN PARSED CONTENT OF EACH CHILD
      return _children; //_.orderBy(_children, "id", ["desc"]);
    },
    tableKeys() {
      let obj = _.clone(this.filteredChildren[0]);
      delete obj.Preclinical;
      delete obj.Link;
      let arr = _.keys(obj);
      // Move "Link" column to last.
      let lastPos = arr.length - 1;
      let linkIndex = arr.indexOf("Link_To_Abstract");
      arr.moveto(linkIndex, lastPos);
      return arr;
    },
    parsedKeys() {
      let k = _.map(this.tableKeys, _.startCase);
      return k;
    }
  }
};
</script>
<style lang="stylus">
.table-wrap
  width 100%
  overflow auto
.publication-table
  table
    width 100%
    min-width 1024px
    border-collapse collapse
    overflow hidden
    border-radius 3px
    table-layout fixed
    th
      cursor pointer
      height 40px
      background blue_5
      color #fff
      padding 5px 10px
      font-size 14px
      min-width 100px
      border-right 1px solid rgba(#fff, 0.9)
      position relative
      .inner-cell
        display inline-flex
        flex-direction row
        align-items center
        justify-content flex-start
        width 100%
        text-align left
      i
        color #fff
        display inline-block
      // &:last-child
      //   border-right none
      &:first-child
        border-left 1px solid rgba(#fff, 0.9)
      &:first-child
        width 25%
      &:nth-child(2)
        width 20%
      &:nth-child(3)
        width 12%
      &:nth-child(5)
        width 65px
    tr
      &:nth-child(odd)
        background gray_1
      td
        padding 10px
        vertical-align top
        font-size 14px
        border-right 1px solid rgba(#fff, 0.2)
        // border-bottom 1px solid rgba(#fff, 0.3)
        &:first-child
          border-left 1px solid rgba(#fff, 0.2)
        span
          max-width 200px
          overflow hidden
          display inline-block
  .responsive-view
    &--section
      background gray_2
    &--item
      &.item__title
        font-weight 400 !important
        font-size 18px
      &.item__author
        font-style italic
        font-size 14px


.showdown
  &-enter-active
  &-leave-active
    transition max-height 0.5s ease-out, padding 0.5s ease-out !important
  &-enter
  &-leave-to
    padding-top 0
    max-height 0px !important
  &-enter-to
  &-leave
    max-height 300px !important
  +portrait()
    max-height 600px
.publication-list
  // width 100%
  &--item
    text-align left
    border-bottom 1px solid rgba(blue_3, 0.5)
    _flex(row, wrap, flex-start, flex-start)
    overflow hidden
    // transition padding 0.6s ease-out-cubic
    // max-width 90%
    +below(815px)
      padding-top 15px
      padding-bottom 15px
    &__wrap
      flex 1
      max-width 90%
    & > i
      flex none
      transition transform 0.4s ease-out-cubic
      margin 3px 0 0 3px
      &.fa-minus
        transform rotate(-180deg)
      &.fa-plus
        transform rotate(-90deg)
    // & > *:not(h4):not(i)
    //   opacity 0
    //   height 0
    //   overflow hidden
    &.is-events
      padding-left 5px
      border-bottom none
      &:nth-child(even)
        background gray_1 //rgba(gray_1, 0.6)
      &:nth-child(odd)
        background rgba(lighten(gray_1, 2), 0.2) //rgba(gray_1, 0.6)
    &.open  > *
      opacity 1
      height 100%
    &:not(.is-events):first-child
      padding-top 0
    &:last-child
      border-bottom 0
    &--title
      color gray_9
    p
      &:last-child
        padding 0
</style>
